import React from 'react'
import { prussian } from 'constants/inlineStyles'

let styles = {}

const DistrictDisclaimer = ({ disclaimer }) => (
  <p style={styles.content}>{disclaimer}</p>
)

styles = {
  content: {
    margin: '60px auto 30px',
    fontSize: '.693333rem',
    lineHeight: '1.153846',
    color: prussian,
    fontWeight: 'normal',
    verticalAlign: 'middle',
    textAlign: 'center',
    maxWidth: '70%'
  }
}

export default DistrictDisclaimer



// WEBPACK FOOTER //
// ./src/screens/Flyers/screens/FlyerGrid/components/FlyerGridBody/components/DistrictDisclaimer.js